import React, { Component } from 'react';
import AutoComplete from 'react-autocomplete';
import Highlighter from 'react-highlight-words';

import { Project } from 'tstypes';

import {
  STextCropper,
  SMenu,
  SMenuItem,
  SNoProjectsResults,
  SSearchContainer,
  SSearchInput,
  SSpinner,
} from './styled';

interface Props {
  projectsAreLoading: boolean;
  currentProject: Project;
  header: React.ReactNode;
  isOpen?: boolean;
  items: Array<Project>;
  value: string;
  changeValue: (value: string) => void;
  closePanel: () => void;
  selectItem: (item: Project) => void;
}

export default class ProjectsMenuOptions extends Component<Props> {
  inputRef: React.RefObject<AutoComplete>;

  constructor(props: Props) {
    super(props);
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  handleKeyUp = (e: React.KeyboardEvent) => {
    const key = e.which;

    if (key === 27) {
      const { value, changeValue, closePanel } = this.props;

      if (value) {
        changeValue('');
      } else {
        closePanel();
      }
    }
  };

  render() {
    const {
      items,
      value,
      isOpen,
      selectItem,
      changeValue,
      header,
      projectsAreLoading,
      currentProject,
    } = this.props;

    return (
      <AutoComplete
        ref={this.inputRef}
        autoHighlight
        getItemValue={item => item.name}
        items={items}
        open={isOpen}
        renderInput={props => (
          <SSearchContainer>
            <div className="icon-project" />
            <SSearchInput
              data-test="project-search-input"
              placeholder="Select or search a project"
              onKeyUp={this.handleKeyUp}
              {...props}
            />
            {projectsAreLoading && <SSpinner isWhite />}
          </SSearchContainer>
        )}
        renderItem={(item, isHighlighted) => (
          <SMenuItem key={item.id} isHighlighted={isHighlighted}>
            <STextCropper text={item.name}>
              <Highlighter
                autoEscape
                highlightStyle={{
                  borderBottom: '1px solid #F5F5F5',
                }}
                searchWords={[value]}
                textToHighlight={item.name}
              />
            </STextCropper>
          </SMenuItem>
        )}
        renderMenu={children => (
          <SMenu>
            {header}
            {children.length > 0 && children}
            {children.length === 0 && !projectsAreLoading && (
              <SNoProjectsResults data-test="no-projects-text">
                No projects found for {`'${value}'`}
              </SNoProjectsResults>
            )}
          </SMenu>
        )}
        shouldItemRender={item => item.name !== currentProject.name}
        value={value}
        wrapperStyle={{ display: 'block' }}
        onChange={(event, value) => changeValue(value)}
        onSelect={(value, item) => selectItem(item)}
      />
    );
  }
}
